import React, { useState } from 'react';
import classes from './index.module.scss';
import { Link, useHistory } from 'react-router-dom';
import { scheduleEmailsDelete, scheduleSmsDelete } from '../../api';
import DeleteReport from './DeleteReport';
import { HashLink } from 'react-router-hash-link';

const MessageOptions = ({ template_id, type, handleDefaultStatusCodes, setLoading }) => {
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId('');
  }

  const onDeleteReport = (e, id) => {
    setShowDeleteModal(true);
    setDeleteId(id);
    e.preventDefault();
  }

  const link = type === 'email' && '/schedule-emails' || type === 'sms' && '/schedule-sms';

  const deleteMessage = () => {
    switch (type) {
      case 'email':
        emailRequest()
        break;
      case 'sms':
        smsRequest()
        break;
      default:
        setLoading(false);
    }
  }

  const emailRequest = () => {
    setLoading(true);
    scheduleEmailsDelete(template_id)
      .then(() => {
        setLoading(false);
        history.push(link);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      });
  }

  const smsRequest = () => {
    setLoading(true);
    scheduleSmsDelete(template_id)
      .then(() => {
        setLoading(false);
        history.push(link);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
      });
  }

  return (
    <div className={classes.Message_Footer}>
      <div>
        <Link
          to={`/update-${type}-schedule?template_id=${template_id}&type=${type}`}
          className="btnSizes btnSizes filledBtn"
        >
          Edit
        </Link>
        <Link
          to={link}
          className="btnSizes transparentBtn border-0 ml-5"
        >
          Cancel
        </Link>
      </div>
      <HashLink
        onClick={(e) => onDeleteReport(e, template_id)}
        to='#'
        className="btnSizes defaultBtn ml-4"
        smooth
      >
        Delete
      </HashLink>
      { showDeleteModal && <DeleteReport deleteMessage={deleteMessage} closeDeleteModal={closeDeleteModal} showDelete={showDeleteModal}/> }
    </div>
  )
}

export default MessageOptions;